<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layoutheader></layoutheader>

      <!-- Page Content -->
      <div class="content top-space">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Login Tab Content -->
              <div class="account-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6 login-left">
                    <img src="@/assets/img/banner-cart.png" class="img-fluid" alt="Admin Login" />
                  </div>
                  <div class="col-md-12 col-lg-6 login-right">
                    <div class="login-header">
                      <h3>Admin Dashboard Login</h3>
                      <p class="text-muted text-center">Manage doctors and healthcare services</p>
                    </div>
                    <p v-if="error">
                      <b-alert v-model="showDismissibleAlert" variant="danger" dismissible="">{{ error }}</b-alert>
                    </p>
                    <form @submit.prevent="submitForm">
                      <div class="mb-3 form-focus">
                        <input type="email" class="form-control floating" v-model="email" placeholder="Enter your email" />
                        <label class="focus-label" :class="{ 'has-input': email }">Email</label>
                      </div>
                      <div class="mb-3 form-focus position-relative">
                        <input :type="showPassword ? 'text' : 'password'" class="form-control floating" v-model="password" placeholder="Enter your password" />
                        <label class="focus-label" :class="{ 'has-input': password }">Password</label>
                        <button type="button" class="password-toggle" @click="togglePasswordVisibility">
                          <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                      </div>
                      <div class="text-end mb-3">
                        <router-link class="forgot-link" to="#">Forgot Password?</router-link>
                      </div>
                      <b-button :disabled="working" class="btn btn-primary w-100 btn-lg login-btn" type="submit">
                        <span class="spinner-border spinner-border-sm me-2" role="status" v-if="working"></span>
                        Login
                      </b-button>
                      <div class="text-center mt-3">
                        <p class="text-muted">Not an admin? <router-link to="/doctor-login">Doctor Login</router-link></p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!-- /Login Tab Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->

      <indexfooter />
    </div>
  </div>
</template>

<script>
import { signIn, DOCTOR_POOL } from '@/services/auth';
import axios from "axios"

export default {
  data() {
    return {
      email: '',
      password: '',
      error: null,
      working: false,
      showDismissibleAlert: false,
      showPassword: false,
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    async submitForm() {
      this.working = true;
      this.error = null;
      
      try {
        const { isSignedIn, nextStep } = await signIn(
          { username: this.email, password: this.password, options: { pool: DOCTOR_POOL } }
        );
        console.log(isSignedIn,nextStep)
         if (isSignedIn || nextStep?.signInStep === "DONE") {
            localStorage.setItem('adminEmail', this.email);
            localStorage.setItem('adminLoggedIn', 'true');
            sessionStorage.setItem('useridpid', this.email);
            sessionStorage.setItem('usertype', 'Admin');
            return;
          }
          if (nextStep?.signInStep === "CONFIRM_SIGN_UP") {
            this.error = "You have not yet confirmed your email";
            return;
          }
          console.warn("Unhandled sign-in step:", nextStep);

      } catch (error) {
        this.working = false;
        this.showDismissibleAlert = true;
        if (error.name === "UserNotFoundException") {
          this.error = "Invalid email or password";
        } else if (error.name === "UserNotConfirmedException") {
          this.error = "You have not yet confirmed your email";
        } else {
          console.log('error signing in', error);
          this.error = error.message || "Login failed";
        }
      }
    }
  },
};
</script>

<style scoped>
.account-page {
  background: #f5f7fb;
  min-height: 100vh;
}

.position-relative {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.password-toggle .fas {
  font-size: 1.2em;
  color: #6c757d;
}

.login-header {
  margin-bottom: 30px;
}

.login-header h3 {
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
}

.form-focus {
  position: relative;
  margin-bottom: 20px;
}

.floating {
  padding-top: 24px;
  padding-bottom: 8px;
}

.focus-label {
  position: absolute;
  top: 8px;
  left: 12px;
  font-size: 12px;
  color: #999;
  transition: all 0.3s ease;
}

.focus-label.has-input {
  color: #007bff;
  font-weight: 600;
}

.forgot-link {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
}

.forgot-link:hover {
  text-decoration: underline;
}

.login-btn {
  padding: 10px 20px;
  font-weight: 600;
  border-radius: 4px;
}

.login-btn:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.text-center p {
  font-size: 14px;
}

.text-center a {
  color: #007bff;
  text-decoration: none;
}

.text-center a:hover {
  text-decoration: underline;
}
</style>
